// extracted by mini-css-extract-plugin
export default {"dividerContainer":"UpDownArrows_dividerContainer__yQjpA"};